import "./DateInput.css"

import { forwardRef, useEffect, useRef, useState } from "react"

import "react-day-picker/lib/style.css"
import DayPickerInput from "react-day-picker/DayPickerInput"
import { fromMonth, toMonth, YearMonthForm } from "web/components/DayPicker"

import useCombinedRefs from "web/hooks/behaviour/useCombinedRefs"
import { formatAsDate, formatAs } from "web/services/format"
import { isDate } from "web/services/helpers"

import classNames from "classnames"

import ControlContainer from "./ControlContainer"

function toISODate(date) {
  return formatAsDate({ value: date })
}

const DateInput = forwardRef((props, ref) => {
  const {
    name,
    value,
    touched,
    error,
    onChange,
    onFocus,
    autoFocus,
    disabled = false,
  } = props

  const [month, setMonth] = useState(new Date())
  const [hasError, setHasError] = useState(
    value !== null && value !== undefined && !isDate(value.value)
  )
  const innerRef = useRef()
  const inputRef = useCombinedRefs(ref, innerRef)

  useEffect(() => {
    if (autoFocus) {
      inputRef.current.focus()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function _onChange(date) {
    inputRef.current.focus()
    const newValue = date === undefined ? undefined : toISODate(date)
    if (newValue === undefined) {
      onChange(null)
    } else {
      onChange({ value: newValue, kind: "Date", format: "Date" })
    }

    setHasError(newValue !== "" && !isDate(newValue))
  }

  function _setMonth(month) {
    inputRef.current.focus()
    setMonth(month)
  }

  let errorToDisplay
  if (touched && error) {
    errorToDisplay = error
  } else if (hasError) {
    errorToDisplay = "Please enter a date."
  }

  return (
    <ControlContainer
      {...props}
      error={errorToDisplay}
      errorCondition={!!errorToDisplay}
    >
      <DayPickerInput
        value={formatAs("Date", value)}
        onDayChange={_onChange}
        dayPickerProps={{
          month,
          fromMonth,
          toMonth,
          captionElement: ({ date, localeUtils }) => (
            <YearMonthForm
              date={date}
              localeUtils={localeUtils}
              onChange={_setMonth}
            />
          ),
        }}
        inputProps={{
          type: "text",
          ref: inputRef,
          "data-testid": `form-input-${name}`,
          className: classNames("form-control", { "opacity-50": disabled }),
          placeholder: "YYYY-MM-DD",
          onFocus,
          disabled,
        }}
      />
    </ControlContainer>
  )
})

export default DateInput
